module.exports = __webpack_public_path__ + "img/image32.9a5f6241.png";